"use strict";
/*
 * Created on 20. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Configuration of e-commerce promotion-related application subdomain.
 *
 * @author Radek Beran
 */


var EcommerceAppConfig =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EcommerceAppConfig, _DomainObject_1$Domai);

  /**
   * @param enabled whether e-commerce promotion feature is enabled
   * @param promotionTypeId default promotion type for e-commerce promotions
   * @param groupOfSiteId group of sites for e-commerce promotions
   */
  function EcommerceAppConfig(enabled, promotionTypeId, groupOfSiteId) {
    var _this;

    _classCallCheck(this, EcommerceAppConfig);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EcommerceAppConfig).call(this));
    _this.enabled = enabled;
    _this.promotionTypeId = promotionTypeId;
    _this.groupOfSiteId = groupOfSiteId;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(EcommerceAppConfig, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new EcommerceAppConfig(mat.enabled, mat.promotionTypeId, mat.groupOfSiteId);
    }
  }]);

  return EcommerceAppConfig;
}(DomainObject_1.DomainObject);

exports.EcommerceAppConfig = EcommerceAppConfig;

EcommerceAppConfig.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(EcommerceAppConfig.name);
  return {
    enabled: builder.bool('enabled'),
    promotionTypeId: builder.str('promotionTypeId'),
    groupOfSiteId: builder.str('groupOfSiteId')
  };
}();